<!--  -->
<template>
	<div class="Aboutphone">
		<h1 class="History-title">{{ title }}</h1>
		<swiper :auto-update="true" class="History-swiper" ref="mySwiper" :options="swiperOption1">
			<swiper-slide class="swiper-slide" v-for="(item, index) in HistoryList" :key="index">
				<div class="phoneHistory">
					<h1>{{ item.year }}</h1>
					<ul>
						<li v-for="(i, index) in item.List" :key="index">{{ i.msg }}</li>
					</ul>
				</div>
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
	import {
		Swiper,
		SwiperSlide
	} from "vue-awesome-swiper";
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';

	export default {
		//import引入的组件需要注入到对象中才能使用
		components: {},
		data() {
			//这里存放数据
			return {
				title: "", //发展历程
				HistoryList: [
					// {
					// 	year: "2012",
					// 	List: [{
					// 			msg: "德诺收购Broncus，获取肺部精准定位技术",
					// 		},
					// 		{
					// 			msg: "德诺收购Broncus，获取肺部精准定位技术",
					// 		},
					// 		{
					// 			msg: "德诺收购Broncus，获取肺部精准定位技术",
					// 		},
					// 	],
					// },
					// {
					// 	year: "2013",
					// 	List: [{
					// 			msg: "德诺收购Broncus，获取肺部精准定位技术",
					// 		},
					// 		{
					// 			msg: "德诺收购Broncus，获取肺部精准定位技术",
					// 		},
					// 		{
					// 			msg: "德诺收购Broncus，获取肺部精准定位技术",
					// 		},
					// 	],
					// },
				],
				swiperOption1: {
					observer: true, //修改swiper自己或子元素时，自动初始化swiper
					observeParents: true, //修改swiper的父元素时，自动初始化swiper
					loop: true,

					speed: 500,
					autoplay: {
						delay: 5000,
						disableOnInteraction: false,
					},
				},
			};
		},
		//监听属性 类似于data概念
		computed: {
			Swiper,
			SwiperSlide,
		},
		//监控data中的数据变化
		watch: {},
		//方法集合
		methods: {
			//1.文章列表
			get_data() {
				const that = this;
				$.ajax({
					url: "/index.php?s=Home/Api/get_data",
					type: "get",
					datatype: "json",
					data: {
						act: "article_list",
						category_id: 9,
					},
					success: function(ret) {
						var obj = JSON.parse(ret); //json数据转为数组
						if (obj.code == "0000") {
							that.title = obj.yj_name;

							$.each(obj.data, function(i, k) {
								var msgs = k.msgs.split("<br />");
								var linshi = [];
								$.each(msgs, function(ii, kk) {
									linshi.push({
										msg: kk,
									});
								});

								that.HistoryList.push({
									year: k.title,
									List: linshi,
								});
							});
						}
					},
					error: function(err) {
						console.log("ajax错误");
					},
				});
			},
		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {
			this.get_data();
		},
		beforeCreate() {}, //生命周期 - 创建之前
		beforeMount() {}, //生命周期 - 挂载之前
		beforeUpdate() {}, //生命周期 - 更新之前
		updated() {}, //生命周期 - 更新之后
		beforeDestroy() {}, //生命周期 - 销毁之前
		destroyed() {}, //生命周期 - 销毁完成
		activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>
<style lang='scss' scoped>
	//@import url(); 引入公共css类
	@import "../../../scss/public.scss";

	.Aboutphone {
		width: 100%;
		margin: 0 auto;
		display: none;

		.History-title {
			text-align: center;
			font-size: 1.4rem;
			color: #193895;
		}

		.History-swiper {
			h1 {
				margin: 10px 0;
				text-align: center;
				font-size: 1.3rem;
				color: #333;
			}

			.phoneHistory {
				width: 100%;
				padding: 10px;
			}
		}
	}

	@media screen and (max-width: $main-width) {
		.Aboutphone {
			display: block;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/about/Aboutphone.vue